import {
  ProfileCornerActions,
  ProfileMessage,
  ProfilePrimaryActions,
} from "./ProfileActions";
import { ProfileBadges } from "./ProfileBadges";
import { ProfileBanner } from "./ProfileBanner";
import { ProfileBio } from "./ProfileBio";
import { ProfileCard, ProfileSection } from "./ProfileCard";
import { ProfileIdentity } from "./ProfileIdentity";
import { ProfileJoined } from "./ProfileJoined";
import { ProfileMutualSummary, ProfileMutualTabs } from "./ProfileMutuals";
import { ProfileOwner } from "./ProfileOwner";
import { ProfileRoles } from "./ProfileRoles";
import { ProfileStatus } from "./ProfileStatus";

export const Profile = {
  Actions: ProfilePrimaryActions,
  CornerActions: ProfileCornerActions,
  Message: ProfileMessage,
  Badges: ProfileBadges,
  Banner: ProfileBanner,
  Bio: ProfileBio,
  Card: ProfileCard,
  Section: ProfileSection,
  Identity: ProfileIdentity,
  Joined: ProfileJoined,
  MutualSummary: ProfileMutualSummary,
  MutualTabs: ProfileMutualTabs,
  Roles: ProfileRoles,
  Status: ProfileStatus,
  Owner: ProfileOwner,
};
